<template>
  <div>
    <div
      id="offcanvasChapters"
      class="offcanvas offcanvas-end offcanvas-end--filters d-flex w-50"
      :class="{ show: visible }"
      :style="{ visibility: visible ? 'visible' : 'hidden' }"
      tabindex="-1"
      aria-labelledby="offcanvasFiltersLabel"
    >
      <div class="offcanvas-header">
        <h3
          id="offcanvasResearchLineLabel"
          class="offcanvas-title"
        >
          <span class="btn btn-icon btn-icon rounded-circle btn-flat-secondary bg-light-secondary me-2"><i data-feather="user-plus" /></span>
          Propose new peer {{ blacklist ? 'to blacklist' : '' }}
        </h3>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          @click="closeOffcanva"
        />
      </div>
      <div class="offcanvas-body">
        <div v-if="totalPeers < 3">
          <div class="mb-1">
            <label
              for=""
              class="form-label"
            >Name <span class="text-danger">*</span></label>
            <input
              v-model="user.first_name"
              type="text"
              class="form-control"
            >
          </div>
          <div class="mb-1">
            <label
              for=""
              class="form-label"
            >Surname <span class="text-danger">*</span></label>
            <input
              v-model="user.last_name"
              type="text"
              class="form-control"
            >
          </div>
          <div class="mb-1">
            <label
              for=""
              class="form-label"
            >Institution <span class="text-danger">*</span></label>
            <input
              v-model="user.institution_name"
              type="text"
              class="form-control"
            >
          </div>
          <div class="mb-1">
            <label
              for=""
              class="form-label"
            >Email <span class="text-danger">*</span></label>
            <input
              v-model="user.email"
              type="email"
              class="form-control"
            >
          </div>

          <button
            type="button"
            class="btn btn-primary mb-1 d-grid w-100"
            :disabled="(!user.first_name || !user.last_name || !user.institution_name || !user.email)"
            @click="saveNewEvaluator"
          >
            Propose new peer {{ blacklist ? 'to blacklist' : '' }}
          </button>
        </div>
        <hr>
        <h3>Proposed peers {{ blacklist ? 'to blacklist' : '' }} ({{ totalPeers }}/3)</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Institution</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="peer, index in proposedPeers"
              :key="index"
            >
              <td>{{ peer.first_name }} {{ peer.last_name }}</td>
              <td>{{ peer.institution_name }}</td>
              <td>{{ peer.email }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="removeProposedPeer(index)"
                >
                  Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="offcanvas-footer mt-auto">
        <button
          type="button"
          class="btn btn-success mb-1 d-grid w-100"
          @click="proposeEvaluator"
        >
          Save proposed peers {{ blacklist ? 'to blacklist' : '' }}
        </button>
      </div>
    </div>
    <div
      v-if="visible"
      class="offcanvas-backdrop fade"
      :class="{ show: visible }"
      @click="closeOffcanva"
    />
  </div>
  <!-- -->
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    tableId: {
      type: Number,
      required: false,
      default: null,
    },
    blacklist: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      user: {
        name: 'aa',
      },
      proposedPeers: [],
      alreadyExistingPeers: [],
      alreadyBlacklistedPeers: [],
    }
  },
  computed: {
    ...mapGetters({
      visible: 'modals/proposeEvaluator',
      tableClicked: 'modals/tableClicked',
      userTrue: 'users/user',
      loggedUser: 'auth/admin',
      peers: 'users/peers',
    }),
    totalPeers() {
      return this.proposedPeers.length
    },
  },
  watch: {
    visible() {
      this.alreadyExistingPeers = this.peers.filter(p => !p.pivot.blacklist)
      this.alreadyBlacklistedPeers = this.peers.filter(p => p.pivot.blacklist)
      this.proposedPeers = this.blacklist ? this.alreadyBlacklistedPeers : this.alreadyExistingPeers
    },
  },
  methods: {
    saveNewEvaluator() {
      this.proposedPeers.push(this.user)
      this.user = {
        name: 'aa',
      }
    },
    closeOffcanva() {
      this.$store.dispatch('modals/toggleProposeEvaluator', false)
    },
    async proposeEvaluator() {
      try {
        this.proposedPeers.forEach(async peer => {
          if (peer.first_name.trim() && peer.last_name.trim() && peer.institution_name.trim() && peer.email.trim()) {
            if (peer.email === this.loggedUser.email) {
              Vue.swal('You can\'t propose yourself.', '', 'warning')
            } else {
              await this.$store.dispatch('users/proposePeer', { user: peer, authUser: this.userTrue, blacklist: this.blacklist })
              this.$toastr.success('', `Evaluator ${this.blacklist ? 'blacklisted' : 'proposed'} successfully!`)
              this.$store.dispatch('users/filterEvaluators')
              this.$store.dispatch('users/getPeers', this.userTrue.id)
              this.proposedPeers = []
              this.closeOffcanva()
            }
          } else {
            Vue.swal('Please, fill up all the required fields', '', 'warning')
          }
        })
      } catch (e) {
        Vue.swal('Please, fill up all the required fields', '', 'warning')
      }
    },
    removeProposedPeer(index) {
      this.proposedPeers = this.proposedPeers.filter((peer, i) => i !== index)
    },
  },
}
</script>
